export class PagedResponseModel {
    public totalRecords: number;
    public CurrentPage: number;
    public PageSize: number;
  }
